export default __webpack_public_path__ + "static/assets/med_x_powder_1.5cb14cd8.png";